import React, { useEffect, useState } from "react";
import { Icon } from "./icons";
import "./ManageAbout.css";

/* ✅ CLOUD BACKEND */
const API = "https://backend-9i6n.onrender.com";

const ManageAbout = () => {
  const [form, setForm] = useState({
    name: "",
    history: "",
    populationTotal: "",
    populationMale: "",
    populationFemale: "",
    totalFamilies: "",
    wards: "",
    literacyRate: "",
    area: "",
    description: "",
  });

  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [saved, setSaved] = useState(false);
  const token = localStorage.getItem("token");

  /* ================= FETCH FROM CLOUD ================= */
  useEffect(() => {
    setFetchLoading(true);
    fetch(`${API}/api/village`)
      .then((res) => res.json())
      .then((data) => {
        if (data) setForm(data);
      })
      .catch((err) => console.error("Fetch village error:", err))
      .finally(() => setFetchLoading(false));
  }, []);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setSaved(false);
  };

  /* ================= SAVE TO CLOUD ================= */
  const saveData = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${API}/api/village`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error("Failed to save");

      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (err) {
      console.error("Save error:", err);
      alert("गावाचे तपशील अद्ययावत करता आले नाहीत ❌");
    } finally {
      setLoading(false);
    }
  };

  /* ================= LOADING SKELETON ================= */
  if (fetchLoading) {
    return (
      <div className="admin-page admin-page--form">
        <div className="gp-page-head">
          <h1>गावाची माहिती</h1>
        </div>
        <div className="gp-loading">माहिती लोड होत आहे...</div>
      </div>
    );
  }

  return (
    <div className="admin-page admin-page--form">
      <div className="gp-page-head">
        <div>
          <h1>गावाची माहिती</h1>
          <p>संकेतस्थळावर दाखवली जाणारी गावाची अधिकृत माहिती संपादित करा</p>
        </div>
      </div>

      {saved && (
        <div className="gp-toast gp-toast-success">
          <span>✅</span>
          <p style={{ margin: 0 }}>गावाचे तपशील यशस्वीरित्या जतन झाले</p>
        </div>
      )}

      <div className="about-columns">
        {/* LEFT: FORM */}
        <form className="gp-card about-form-card" onSubmit={saveData}>
          <h2 className="about-card-title">मूलभूत तपशील</h2>

          <div className="about-form-grid">
            <label className="gp-field">
              गावाचे नाव
              <input
                className="gp-input"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
              />
            </label>

            <label className="gp-field">
              लोकसंख्या (एकूण)
              <input
                className="gp-input"
                name="populationTotal"
                type="number"
                value={form.populationTotal}
                onChange={handleChange}
                required
              />
            </label>

            <label className="gp-field">
              पुरुष लोकसंख्या
              <input
                className="gp-input"
                name="populationMale"
                type="number"
                value={form.populationMale}
                onChange={handleChange}
                required
              />
            </label>

            <label className="gp-field">
              महिला लोकसंख्या
              <input
                className="gp-input"
                name="populationFemale"
                type="number"
                value={form.populationFemale}
                onChange={handleChange}
                required
              />
            </label>

            <label className="gp-field">
              क्षेत्रफळ (चौ. कि.मी.)
              <input
                className="gp-input"
                name="area"
                value={form.area}
                onChange={handleChange}
                required
              />
            </label>

            <label className="gp-field">
              एकूण कुटुंबे
              <input
                className="gp-input"
                name="totalFamilies"
                type="number"
                value={form.totalFamilies}
                onChange={handleChange}
              />
            </label>

            <label className="gp-field">
              प्रभाग (वॉर्ड)
              <input
                className="gp-input"
                name="wards"
                type="number"
                value={form.wards}
                onChange={handleChange}
              />
            </label>

            <label className="gp-field">
              साक्षरता दर (%)
              <input
                className="gp-input"
                name="literacyRate"
                type="number"
                value={form.literacyRate}
                onChange={handleChange}
              />
            </label>
          </div>

          <label className="gp-field" style={{ marginTop: 16 }}>
            गावाचा इतिहास
            <textarea
              className="gp-textarea"
              name="history"
              value={form.history}
              onChange={handleChange}
              required
            />
          </label>

          <label className="gp-field" style={{ marginTop: 16 }}>
            अतिरिक्त वर्णन (पर्यायी)
            <textarea
              className="gp-textarea"
              name="description"
              value={form.description}
              onChange={handleChange}
            />
          </label>

          <button type="submit" className="gp-btn gp-btn-blue" disabled={loading} style={{ marginTop: 20 }}>
            {loading ? (
              <>
                <span className="gp-spinner" /> जतन करत आहे...
              </>
            ) : (
              "बदल जतन करा"
            )}
          </button>
        </form>

        {/* RIGHT: QUICK FACTS */}
        <div className="about-side-col">
          <div className="gp-card about-quick-card">
            <h2 className="about-card-title">एका दृष्टिक्षेपात</h2>
            <div className="about-quick-grid">
              <div>
                <div className="about-quick-value">{form.populationTotal || "—"}</div>
                <div className="about-quick-label">लोकसंख्या</div>
              </div>
              <div>
                <div className="about-quick-value">{form.populationMale || "—"}</div>
                <div className="about-quick-label">पुरुष</div>
              </div>
              <div>
                <div className="about-quick-value">{form.populationFemale || "—"}</div>
                <div className="about-quick-label">महिला</div>
              </div>
              <div>
                <div className="about-quick-value">{form.area || "—"}</div>
                <div className="about-quick-label">क्षेत्रफळ</div>
              </div>
              <div>
                <div className="about-quick-value">{form.totalFamilies || "—"}</div>
                <div className="about-quick-label">एकूण कुटुंबे</div>
              </div>
              <div>
                <div className="about-quick-value">{form.wards || "—"}</div>
                <div className="about-quick-label">प्रभाग (वॉर्ड)</div>
              </div>
              <div>
                <div className="about-quick-value">
                  {form.literacyRate ? `${form.literacyRate}%` : "—"}
                </div>
                <div className="about-quick-label">साक्षरता दर</div>
              </div>
            </div>
          </div>

          <div className="about-tip-card">
            <Icon.info size={18} />
            <p>
              येथील माहिती सार्वजनिक "गावाची माहिती" पानावर लगेच दिसू लागते —
              जतन करण्यापूर्वी तपासा.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageAbout;
